module.exports = __webpack_public_path__ + "img/title-5.d2fb6f01.png";